
import { ShopApi } from "../../common/constants/shop-api";
import environment from "../../common/environment";
import { getResponseData } from "../../common/utils/api-utils";
import { OrderHistory } from "./order-history.interface";
import { mapOrderHistoryMagentoResponse, mapOrderHistoryShopResponse } from './order-history.mapping';
import { OrderHistoryParams } from "./order-history.thunks";

// [SHOP-API-REMOVAL][WECOMM-20796] `getOrderHistoryApiCall` (Shop
// /store/api/v1/checkout/payment/order-history) has been removed. It had no
// callers in source or tests. Magento now serves order history via
// `getOrderHistoryMagentoApiCall` + `getOrderHistoryShopMagentoApiCall`.

export async function getOrderHistoryShopMagentoApiCall(token: string): Promise<OrderHistory[]> {
    const url = new URL(`${environment().magentoUrl}${ShopApi.ordersHistoryShopMagento}`);
    return mapOrderHistoryShopResponse(await getResponseData(
        new Request(url.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
    ));
}

export async function getOrderHistoryMagentoApiCall(params: OrderHistoryParams, token: string): Promise<OrderHistory[]> {
    const url = _getOrderHistoryURL(params);
    return mapOrderHistoryMagentoResponse(await getResponseData(
        new Request(url.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
    ));
}

function _getOrderHistoryURL(param: OrderHistoryParams): URL {
    const url = new URL(environment().magentoUrl + ShopApi.ordersHistoryMagento);
    if (param.currentPage) {
      url.searchParams.append("searchCriteria[currentPage]", param.currentPage);
    }
    if (param.pageSize) {
        url.searchParams.append("searchCriteria[pageSize]", param.pageSize);
    }
    url.searchParams.append("searchCriteria[sortOrders][1][direction]", 'DESC');
    url.searchParams.append("searchCriteria[sortOrders][0][field]", 'created_at');
  
    return url;
}